export function SetPayTypeId(payTypeId) {
	return <option value={payTypeId.id}>{payTypeId.description}</option>;
}